module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vulpecula/vul_oc-8eb1ff5a3a3d9e31d37895e8a9901bf1.gif";